import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Untrackable } from '../../abstract/Document';
import { Countries, type Country } from '../Countries';
import type { ICountry } from '../Countries.types';
import type { IBucket } from './Buckets.types';
import { mergeDeepRight } from 'ramda';

@Identifiable
@Untrackable
export class Bucket extends AbstractDocument<IBucket> {
  readonly collections = {};

  /**
   * Extract the country ID from the document reference.
   */
  get country(): ICountry['id'] {
    return this.reference.parent.parent!.id as ICountry['id'];
  }

  /**
   * Recursively merges documents from different countries.
   */
  async get(data?: boolean): Promise<any> {
    if (data === false) {
      throw new Error('DocumentSnapshot is not supported by this implementation.');
    }

    let result = await super.get(true);

    if (this.country !== '*') {
      result = mergeDeepRight(await Countries._.getById('*').Buckets.getById(result.id).get(true), result) as IBucket;
    }

    return result;
  }
}

export class Buckets extends AbstractCollection<Bucket, IBucket> {
  static path = 'buckets';

  constructor(document: Country) {
    super(document.collection(Buckets.path), Bucket);
  }

  /**
   * Extract the country ID from the collection reference.
   */
  get country(): ICountry['id'] {
    return this.reference.parent!.id as ICountry['id'];
  }

  /**
   * Recursively merges the sub-collection from different countries.
   */
  async all() {
    let result = await this.query().get(true);

    if (this.country !== '*') {
      result = mergeDeepRight(await Countries._.getById('*').Buckets.all(), result) as Record<string, IBucket>;
    }

    return result;
  }
}
